import { defineStore } from "pinia";
import { NOTIFICATION_TYPES } from "@/constants/notificationTypes";
import { notificationService } from '@/services/notificationService'

export const useNotificationStore = defineStore("notification", {
  state: () => ({
    notifications: [],
    maxNotifications: 5,
  }),

  actions: {
    async addNotification(notification) {
      console.log('Recibiendo notificación:', notification);

      // Agregar a la lista de notificaciones en pantalla
      const newNotification = {
        id: Date.now(),
        ...notification
      };
      this.notifications.push(newNotification);

      if (!notification.inAppOnly) {
        // Intentar mostrar notificación del sistema
        try {
          await notificationService.showNotification(
            notification.title,
            {
              message: notification.message,
              data: notification.data
            }
          );
        } catch (error) {
          console.error('Error al mostrar notificación del sistema:', error);
        }
      }

      // Auto-eliminar después de 5 segundos
      setTimeout(() => {
        this.removeNotification(newNotification.id);
      }, notification.durationMs ?? 5000);
    },

    /** Toast solo en pantalla (sin bandeja del sistema) — guards de ruta Fase 3 */
    addInAppToast({ title, message, durationMs = 6000 }) {
      return this.addNotification({
        title,
        message,
        inAppOnly: true,
        durationMs,
        type: "access-denied",
      });
    },

    removeNotification(id) {
      this.notifications = this.notifications.filter(n => n.id !== id);
    },

    markAsRead(id) {
      const notification = this.notifications.find((n) => n.id === id);
      if (notification) {
        notification.read = true;
      }
    },

    clearAll() {
      this.notifications = [];
    },

    playNotificationSound(type) {
      // Diferentes sonidos según el tipo
      const sounds = {
        [NOTIFICATION_TYPES.SUCCESS]: "/sounds/success.mp3",
        [NOTIFICATION_TYPES.ERROR]: "/sounds/error.mp3",
        [NOTIFICATION_TYPES.PAYMENT]: "/sounds/payment.mp3",
        default: "/sounds/notification.mp3",
      };

      const audio = new Audio(sounds[type] || sounds.default);
      audio.play().catch(() => {}); // Ignorar errores de reproducción
    },
  },
});
